import { html, mount } from '../core/html.js';
import { get, post } from '../core/api.js';
import { emptyState } from '../core/ui.js';
import { fmtTs } from '../core/format.js';
import { t } from '../core/i18n.js';

const LINK = (n) => (n.data?.booking_id ? `#/bookings/${n.data.booking_id}` : n.data?.conversation_id ? `#/messages/${n.data.conversation_id}` : n.data?.withdrawal_id ? '#/host/withdrawals' : n.data?.dispute_id ? '#/admin/disputes' : n.data?.property_id ? '#/host/properties' : n.data?.ticket_id ? '#/support' : null);

export async function render(main) {
  // Pelayan memulangkan tajuk & isi dalam bahasa permintaan semasa (X-Locale).
  const list = await get('/api/notifications');
  mount(main, html`<div class="wrap" style="max-width:720px;padding-top:20px"><h1>${t('nav.notifications')}</h1>
    ${list.length ? html`<div class="list">${list.map((n) => html`<a class="item" href="${LINK(n) || '#/notifications'}" style="${n.read ? '' : 'border-color:var(--sungai);background:var(--sungai-tint)'}"><span class="grow"><b>${n.title}</b><div class="small">${n.body}</div><div class="tiny muted">${fmtTs(n.created_at)}</div></span></a>`)}</div>` : emptyState(t('notifications.empty_title'), t('notifications.empty_text'))}</div>`);
  const unread = list.filter((n) => !n.read).map((n) => n.id);
  if (unread.length) post('/api/notifications/read', { ids: unread }).catch(() => {});
}
